import { FieldActivityMix } from './fieldActivityMix';
import { TenantGeneralData } from './tenantGeneralData';
import { FieldActivity } from './fieldActivity';
import { StableActivity } from './stableActivity';
import { MultipleContainersQuantityDto } from './multipleContainersQuantityDto';

export class ContainerActivity extends TenantGeneralData {
  type: string;
  quantity: number;
  codeShip: string;
  supplier: string;
  supplierId: number;
  attachmentUrl?: string;
  activityDate: Date;
  finalDate?: Date;
  container: any;
  fieldActivityMixes: Array<FieldActivityMix>;
  category?: string;
  note?: string;
  fieldActivityMixUuid?: string;
  fieldActivity: FieldActivity;
  stableActivity: StableActivity;
  unit?: string;
  users?: Array<any>;
  equipments?: Array<any>;
  workHours?: number;
  workedMinutes?: number;
  uuid?: string;
  from?: Date;
  to?: Date;
  commodityId?: number;
  sourceList?: Array<MultipleContainersQuantityDto>;
  imgUrl?: string;
  incomingLoadHumidity?: number;
  finalHumidity?: number;
  dryingTemperature?: number;
  dose?: number;
  dryingDelta?: number;
  dryDose?: number;
  loadIds?: Array<number>;
  loads?: Array<any>;
  movement?: string;
  usersName?: Array<any>;
  depositName?: string;
  extendedUsers?: Array<any>;
  tractorNames?: Array<any>;
  equipmentNames?: Array<any>;
  productName?: any;
  hasProductSpecificPeriod?: boolean;
  productPeriodFrom?: Date | string | null;
  productPeriodTo?: Date | string | null;
  // Array of products for the tanning activity
  containerActivityMix?: Array<FieldActivityMix>;
  // Initial quantity of the container for the tanning activity
  initialQuantity?: number;
  // Water volume used quantity of the container for the tanning activity
  waterVolumeUsed?: number;
  // waste quantity of the container for the tanning activity
  wasteQuantity?: number;
  cropYear?: number;
  treatedVolume?: number;
  warehouseId?: number;
  temperatureStart?: number;
  timeToReachTargetMinutes?: number;
  temperatureValidation?: boolean;

  constructor() {
    super();
    this.id = null;
    this.type = null;
    this.quantity = null;
    this.codeShip = null;
    this.supplier = null;
    this.supplierId = null;
    this.attachmentUrl = null;
    this.activityDate = null;
    this.container = null;
    this.fieldActivityMixes = [];
    this.category = null;
    this.note = null;
    this.fieldActivityMixUuid = null;
    this.fieldActivity = null;
    this.stableActivity = null;
    this.unit = null;
    this.users = null;
    this.equipments = null;
    this.workHours = null;
    this.workedMinutes = null;
    this.uuid = null;
    this.from = null;
    this.to = null;
    this.commodityId = null;
    this.sourceList = null;
    this.imgUrl = null;
    this.dose = null;
    this.incomingLoadHumidity = null;
    this.finalHumidity = null;
    this.dryingTemperature = null;
    this.dryingDelta = null;
    this.dryDose = null;
    this.loadIds = null;
    this.finalDate = null;
    this.movement = null;
    this.usersName = null;
    this.depositName = null;
    this.extendedUsers = null;
    this.tractorNames = null;
    this.equipmentNames = null;
    this.productName = null;
    this.hasProductSpecificPeriod = null;
    this.productPeriodFrom = null;
    this.productPeriodTo = null;
    this.containerActivityMix = [];
    this.initialQuantity = null;
    this.waterVolumeUsed = null;
    this.wasteQuantity = null;
    this.cropYear = null;
    this.warehouseId = null;
    this.treatedVolume = null;
    this.temperatureStart = null;
    this.timeToReachTargetMinutes = null;
    this.temperatureValidation = null;
  }
}

/*
*********** MODELLO DI BACKEND **********************

package com.xfarm.api.v1.core

import com.xfarm.api.v1.auth.User
import grails.databinding.BindingFormat

class ContainerActivity {
    transient springSecurityService

    Long    companyId = -1
    string type
    Double quantity
    string codeShip
    string supplier
    string attachmentUrl
    @BindingFormat('yyyy-MM-dd')
    Date   activityDate
    Date   dateCreated
    Date   lastUpdated

    static belongsTo = [container:Container]

    static constraints = {
        type            blank: false, nullable: false, inList: ['download', 'use', 'buy']
        quantity        nullable: false
        codeShip        blank: false, nullable: true
        supplier        blank: false, nullable: true
        attachmentUrl   blank: false, nullable: true, url: true
        activityDate    blank: false, nullable: false
    }

    static mapping = {
        autoTimestamp true
    }

    def beforeInsert() {
        companyId = User.get(springSecurityService?.principal?.id)?.farm?.id
    }

    def beforeUpdate() {
        if(companyId != User.get(springSecurityService?.principal?.id)?.farm?.id){
            return false
        }
    }

}

*/
